<template>
  <div>
    <section class="fix-header">
      选项内容
      <i
        class="el-icon-circle-plus-outline"
        @click="addOptionsItem"
      />
    </section>
    <section
      v-for="(item, index) in options"
      :key="index"
      class="fix-list"
    >
      <div class="fix-list__option">
        <el-input
          v-model="options[index]"
          placeholder="请输入内容"
        />
      </div>
      <div
        class="fix-list__cate"
        @click="deleteOptions(index)"
      >
        <i class="el-icon-delete" />
      </div>
    </section>
  </div>
</template>
<script>
import { getRandwords } from '@/utils'
import mixin from '@/view/weappTmp/core/lib/package/element-node-mixin.js'
export default {
  name: 'SpAddOption',
  mixins: [mixin],
  data () {
    return {
      options: [],
      defaultValue: ''
    }
  },
  methods: {
    addOptionsItem () {
      console.log('SpAddOption:this.options',this.options)
      this.options.push('')
    },
    deleteOptions (index) {
      this.options.splice(index, 1)
    }
  }
}
</script>

<style scoped lang="scss">
.fix-header {
  margin-bottom: 15px;
  font-size: 14px;
  .el-icon-circle-plus-outline {
    font-size: 20px;
    color: #409eff;
  }
}
.fix-list {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  &__option {
    flex: 1;
  }
  &__cate {
    width: 100px;
    z-index: 99;
    .el-icon-delete {
      color: red;
    }
  }
}
</style>
